<template>
	<header class="topo topo--desktop">
		<div class="container">
			<slot name="logo"></slot>
			<slot name="telefone"></slot>
			<slot name="menu"></slot>
		</div>
	</header>
</template>

